<p class="non-editable" [class]="cell?.classes" [ngStyle]="cell?.styles" [class.checkbox]="cell?.type === 'checkbox'">
  @switch (cell?.type) {
    @case ("checkbox") {
      <input
        type="checkbox"
        [class]="cell?.childClasses"
        [ngStyle]="cell?.childStyles"
        [(ngModel)]="cell!.data['$Selected']"
        [tooltip]="getTooltipValue(cell?.tooltip)"
        placement="left"
        container="body"
        [disabled]="cell?.disabled"
        (change)="onCellChange($event, cell?.data, columnTitle, row!, null)"
      />
    }
    @case ("textarea") {
      <textarea
        type="text"
        [class]="cell?.childClasses"
        [ngStyle]="cell?.childStyles"
        [tooltip]="getTooltipValue(cell?.tooltip)"
        [cols]="cell?.columns || 40"
        [rows]="cell?.rows || 2"
        placement="right"
        [disabled]="cell?.disabled"
        [pattern]="cell?.pattern"
        [(ngModel)]="cell!.value"
        [placeholder]="cell?.placeholder || ''"
        (keyup)="onCellChange($event, cell?.data, columnTitle, row!, null)"
      ></textarea>
    }
    @case ("text") {
      <input
        type="text"
        [class]="cell?.childClasses"
        [ngStyle]="cell?.childStyles"
        [tooltip]="getTooltipValue(cell?.tooltip)"
        placement="right"
        [disabled]="cell?.disabled"
        [pattern]="cell?.pattern"
        [(ngModel)]="cell!.value"
        [placeholder]="cell?.placeholder || ''"
        (keyup)="onCellChange($event, cell?.data, columnTitle, row!, null)"
      />
    }
    @case ("select") {
      <select
        [name]="columnTitle"
        class="table-cell-select"
        [(ngModel)]="cell!.selected"
        [style.background-color]="cellValueIncludes(cell?.value, cell?.selected) ? null : backgroundColors.danger"
        [class]="cell?.childClasses"
        [ngStyle]="cell?.childStyles"
        [tooltip]="getTooltipValue(cell?.tooltip)"
        placement="right"
        [disabled]="cell?.disabled"
        (change)="onCellChange($event, cell?.data, columnTitle, row!, null)"
      >
        @if (!cellValueIncludes(cell?.value, cell?.selected)) {
          <option [value]="cell?.selected">
            {{ cell?.selected }}
          </option>
        }
        @for (value of getCellValueAsArray(cell?.value); track $index) {
          <option [value]="value">
            {{ value }}
          </option>
        }
      </select>
    }
    @case ("a") {
      @if (cell?.href) {
        @switch (isArray(cell?.value)) {
          @case (true) {
            @for (value of getCellValueAsArray(cell?.value); track $index; let i = $index) {
              <a
                [tooltip]="cell?.tooltip?.[i]"
                [href]="cell?.href?.[i]"
                [class]="cell?.childClasses"
                [ngStyle]="cell?.childStyles"
                target="_blank"
              >
                {{ value || "--" }}

                @if (cell?.icons?.[i]) {
                  <app-vficon [iconName]="cell?.icons?.[i]" iconPack="source-system-icons"></app-vficon>
                }
              </a>
            }
          }
          @default {
            <a
              [tooltip]="getTooltipValue(cell?.tooltip)"
              placement="right"
              [href]="cell?.href"
              [class]="cell?.childClasses"
              [ngStyle]="cell?.childStyles"
              target="_blank"
            >
              {{ getCellValueAsStringOrDash(cell?.value) }}

              @if (cell?.icons) {
                <app-vficon [iconName]="getIconNameValue(cell?.icons)" iconPack="source-system-icons"></app-vficon>
              }
            </a>

            @if (!cell?.icons && !emptyValues.includes(getCellValueAsStringOrDash(cell?.value).trim())) {
              <app-vficon
                class="clickable position-relative ms-2 cell-copy-icon"
                tooltip="Click to copy"
                size="14px"
                (click)="handlers.copyValue(getCopyValue())"
                [title]="getCellValueLength(cell?.value) > 10 ? getCellValueAsString(cell?.value) : ''"
                iconName="copy"
                iconPack="source-system-icons"
              ></app-vficon>
            }
          }
        }
      } @else {
        @switch (isArray(cell?.value)) {
          @case (true) {
            @for (value of getCellValueAsArray(cell?.value); track $index; let i = $index) {
              <a
                [tooltip]="cell?.tooltip?.[i]"
                [routerLink]="cell?.routerLink?.[i]"
                [queryParams]="cell?.queryParams?.[i]"
                [class]="cell?.childClasses"
                [ngStyle]="cell?.childStyles"
                target="_blank"
              >
                {{ value || "--" }}
                @if (cell?.icons?.[i]) {
                  <app-vficon [iconName]="cell?.icons?.[i]" iconPack="source-system-icons"></app-vficon>
                }
              </a>
            }
          }
          @default {
            <a
              [tooltip]="getTooltipValue(cell?.tooltip)"
              placement="right"
              [routerLink]="cell?.routerLink"
              [queryParams]="cell?.queryParams"
              [class]="cell?.childClasses"
              [ngStyle]="cell?.childStyles"
              target="_blank"
            >
              {{ getCellValueAsStringOrDash(cell?.value) }}
              @if (cell?.icons) {
                <app-vficon [iconName]="getIconNameValue(cell?.icons)" iconPack="source-system-icons"></app-vficon>
              }
            </a>
            @if (!cell?.icons && !emptyValues.includes(getCellValueAsStringOrDash(cell?.value).trim())) {
              <app-vficon
                class="clickable position-relative ms-2 cell-copy-icon"
                tooltip="Click to copy"
                size="14px"
                (click)="handlers.copyValue(getCopyValue())"
                iconName="copy"
                iconPack="source-system-icons"
              ></app-vficon>
            }
          }
        }
      }
    }
    @case ("button") {
      <button
        [type]="cell?.type"
        [class]="cell?.childClasses"
        [ngStyle]="cell?.childStyles"
        [tooltip]="getTooltipValue(cell?.tooltip)"
        placement="right"
        [disabled]="cell?.disabled"
        [routerLink]="cell?.routerLink"
        [queryParams]="cell?.queryParams"
        (click)="
          onCellChange($event, cell?.data, columnTitle, row!, {
            label: cell?.label,
          })
        "
      >
        <span>{{ cell?.label }}</span>
        @if (cell?.icons) {
          <app-vficon
            size="15px"
            color="white"
            [iconName]="getIconNameValue(cell?.icons)"
            class="float-end ms-2"
            iconPack="source-system-icons"
          ></app-vficon>
        }
      </button>
    }
  }
</p>
